import React from "react";
import PropTypes from "prop-types";

/**
 * Reusable form field wrapper.
 * Props:
 *   label      – field label text
 *   required   – shows red asterisk
 *   badge      – small pill next to label (e.g. "Optional")
 *   helperText – muted text below the input
 *   children   – the actual input / select / textarea element
 */
export default function FormField({ label, required, badge, helperText, error, errorText, children }) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-slate-800">
          {label}
          {required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
        {badge && (
          <span className="text-xs px-2 py-0.5 rounded-full border border-gray-300 text-gray-400">
            {badge}
          </span>
        )}
      </div>
      {children}
      {error && errorText
        ? <p className="gl-field-error">{errorText}</p>
        : helperText && <p className="text-xs text-slate-400">{helperText}</p>
      }
    </div>
  );
}

FormField.propTypes = {
  label:      PropTypes.string.isRequired,
  required:   PropTypes.bool,
  badge:      PropTypes.string,
  helperText: PropTypes.string,
  error:      PropTypes.bool,
  errorText:  PropTypes.string,
  children:   PropTypes.node.isRequired,
};
